import { httpClient } from "../http/httpClient"

export interface GetFilesResponse {
  codigoDocumento: string;
	nomeDocumento: string;
	urlDocumento: string;
}
export async function getFiles(clientId: string) {
  const response = await httpClient
    .get<GetFilesResponse[]	>(`/crefisa/files/${clientId}`)
    .catch((error) => {
      throw error.response?.data || error
    })
  return response.data
}